export const insuranceRouteDef = [
    {
        path: ':resource/design',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'insurance_billing_item_miscllaneous',
            action: 'ADD',
        }
    },
     {
        path: ':resource/design1',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'insurance_billing_miscllaneous',
            action: 'ADD',
        }
    },
    {
        path: 'bill_history_view',
        component: 'PaymentModeExtendedComponent',
        data: {
            selector: 'kx-payment-mode-extended',
            resource: 'bill_history_view',
            action: 'LIST',
        }
    },
    {
        path: 'referral_request_approval_denied_form',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'referral_request_approval_denied_form',
            action: 'MODIFY',
        }
    },
    {
        path: ':id/bill_view/viewbill',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'bill_view',
            action: 'VIEW'
        }
    },
    {
        path: ':id/submitted_bill_queries/billingDesign',
        component: 'SharedUEngineComponent',
        data: {
            selector: 'app-shared-u-engine',
            resource: 'submitted_bill_queries',
            action: 'VIEW',
            screen:'query'
        }
    },
    {
        path: ':id/submitted_bill_queries/billingDesignapprove',
        component: 'SharedUEngineComponent',
        data: {
            selector: 'app-shared-u-engine',
            resource: 'submitted_bill_queries',
            action: 'VIEW',
            screen:'approve'
        }
    },
    {
        path: ':id/submitted_bill_queries/billingDesignanswer',
        component: 'SharedUEngineComponent',
        data: {
            selector: 'app-shared-u-engine',
            resource: 'submitted_bill_queries',
            action: 'VIEW',
            screen:'answer'
        }
    },
    {
        path: ':id/submitted_bill_queries/billingDesignverify',
        component: 'SharedUEngineComponent',
        data: {
            selector: 'app-shared-u-engine',
            resource: 'submitted_bill_queries',
            action: 'VIEW',
            screen:'verify'
        }
    },
    
    {
        path: ':id/bill_view_preauth/viewpreauth',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'bill_view_preauth',
            action: 'VIEW'
        }
    },
    {
        path: 'nhcxAuthorization',
        component: 'NhcxAuthorizationComponent',
        data: {
            selector: 'app-nhcx-authorization',
            resource:'nhcx_authorization_request',
            input:'nhcx_authorization_request',
            action:'ADD'
        }
    }, 
    {
        path: 'nhcxresubmitAuthorization',
        component: 'NhcxAuthorizationComponent',
        data: {
            selector: 'app-nhcx-authorization',
            resource:'nhcx_authorization_resubmit',
            input:'nhcx_authorization_resubmit',
            action:'ADD'
        }
    },
    {
        path: 'nhcxAuthorizationEnhancement',
        component: 'NhcxAuthorizationComponent',
        data: {
            selector: 'app-nhcx-authorization',
            resource:'nhcx_authorization_enhancement',
            input:'nhcx_authorization_enhancement',
            action:'ADD'
        }
    },
    {
        path: 'nhcxQueryAuthorization',
        component: 'NhcxAuthorizationComponent',
        data: {
            selector: 'app-nhcx-authorization',
            resource:'nhcx_authorization_query',
            input:'nhcx_authorization_query',
            action:'ADD'
        }
    },
    {
        path: 'nhcxAuthorizationView',
        component: 'NhcxAuthorizationComponent',
        data: {
            selector: 'app-nhcx-authorization',
            resource:'nhcx_authorization_request',
            input:'nhcx_authorization_request',
            action:'VIEW'
        }
    },
   
]
